import {ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnInit} from "@angular/core";
import {BasePage} from "~/app/pages/base.page";
import {CoreService} from "~/app/core/core.service";
import {OfferInfo} from "~/app/core/model/rpc/offer-info";
import {Title} from "@angular/platform-browser";
import {NavigationService} from "~/app/core/navigation.service";

@Component({
    selector: "all-offers",
    templateUrl: "./all-offers.page.html",
    styleUrls: ["./all-offers.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllOffersPage extends BasePage implements OnInit{
    offers: Array<OfferInfo>;
    constructor(
        private readonly core: CoreService,
        private readonly cd: ChangeDetectorRef,
        private readonly titleService: Title,
    ) {
        super();
        this.titleService.setTitle('All Offers');
    }

  ngOnInit(): void {
    this.core.rpc.OfferAll().then(offerInfoList => {
      this.offers = offerInfoList.offers;
      this.cd.detectChanges();
    });
  }
}
